import React, { Component } from 'react';
import PropTypes from 'prop-types';

class ActivityPopoverContainer extends Component {
  render() {
    return <div className="activity-popover">{this.props.children}</div>;
  }
}

ActivityPopoverContainer.propTypes = {
  children: PropTypes.any
};

export default ActivityPopoverContainer;
